import {Fragment, PropsWithChildren, useMemo} from 'react'
import {useCallback, useLayoutEffect, useRef, useState} from '@wordpress/element'
import useDisclosure from '../core/hooks/useDisclosure'
import Modal from '../core/Modal'
import {BaseProps} from "../types";

export default function HeaderNavBarMobile(props: BaseProps<any>) {
  const {open, handler} = useDisclosure()
  const [data, setData] = useState<Record<string, any>>()

  useLayoutEffect(() => {
    const menuDataDOM = document.querySelector('#nav-menu-data')
    const data = JSON.parse(menuDataDOM.textContent)
    setData(data)
  }, [])

  const renderMenu = useCallback((menus: any[], level: number = 0) => {
    if (!menus) return null
    return menus.map((menu, index) => {
      return (
        <div key={index} className={'text-primary'}>
          <div className={'py-2 border-b'} style={{ paddingLeft: 16 + level * 16}}>
            <a className="block" href={menu.url} dangerouslySetInnerHTML={{__html: menu.title}}/>
          </div>
          {Array.isArray(menu.children) && renderMenu(menu.children, level + 1)}
        </div>

      )
    })
  }, [])

  return (
    <Fragment>
      <div onClick={handler.open}>
        <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1.5" y1="1.5" x2="23.5" y2="1.5" stroke="#134E64" strokeWidth="3" strokeLinecap="round"/>
          <line x1="1.5" y1="8.5" x2="23.5" y2="8.5" stroke="#134E64" strokeWidth="3" strokeLinecap="round"/>
          <line x1="1.5" y1="15.5" x2="23.5" y2="15.5" stroke="#134E64" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>
      <Modal
        open={open}
        onCancel={handler.close}
        width={''}
        height={'100%'}
        align={'end'}
      >
        <div className={'pt-[50px]'}>
          { renderMenu(data ? Object.values(data) : null) }
        </div>
      </Modal>
    </Fragment>
  )
}